import { GET_PORTAL_NOTICE } from '../../constants';

export type PortalNoticeType = 'info' | 'warning' | 'critical';

export interface PortalNotice {
  key: string;
  type: PortalNoticeType;
  title: string;
  text: string;
}

export interface PortalNoticeState {
  error: unknown;
  data: PortalNotice | null;
  loaded: boolean;
  loading: boolean;
}

const initialState: PortalNoticeState = {
  error: null,
  data: null,
  loaded: false,
  loading: false,
};

export const portalNoticeReducer = (
  state = initialState,
  action: { type?: string; result?: any; error?: any } = {},
): PortalNoticeState => {
  switch (action.type) {
    case `${GET_PORTAL_NOTICE}_PENDING`:
      return { ...state, error: null, loading: true };

    case `${GET_PORTAL_NOTICE}_SUCCESS`:
      return {
        ...state,
        error: null,
        data: action.result?.key ? action.result : null,
        loaded: true,
        loading: false,
      };

    case `${GET_PORTAL_NOTICE}_FAIL`:
      return {
        ...state,
        error: action.error,
        data: null,
        loaded: true,
        loading: false,
      };

    default:
      return state;
  }
};

export default portalNoticeReducer;
